import { render, staticRenderFns } from "./recallDialog.vue?vue&type=template&id=1f62c73c"
import script from "./recallDialog.vue?vue&type=script&lang=js"
export * from "./recallDialog.vue?vue&type=script&lang=js"
import style0 from "./recallDialog.vue?vue&type=style&index=0&id=1f62c73c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports